import { CircularProgress, TextField } from "@mui/material";

type Props = {
	value: string | null | undefined;
	loading?: boolean;
};

export const WorkOrderNumberField = ({ value, loading }: Props) => (
	<TextField
		label="Work Order #"
		value={value ?? "—"}
		size="small"
		fullWidth
		disabled
		slotProps={{
			input: {
				endAdornment: loading ? <CircularProgress size={18} /> : undefined,
			},
		}}
	/>
);
